import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TabComponent } from 'rte-library';
import { ProviderComponent } from './reports/components/provider/provider/provider.component';
import { EntityComponent } from './reports/components/entity/entity/entity.component';
import { ReportComponent } from './reports/components/report/report/report.component';
import { UserComponent, AssemblyRegisterComponent, SearchApplicationComponent, MenuComponent} from 'rte-core-app';
import { ReportViewComponent } from './reports/components/report-view/report-view/report-view.component';
import { ReportMenuPreViewComponent } from './reports/components/report/report-menu-pre-view/report-menu-pre-view.component';


const routes: Routes = [
  { path: '', component: MenuComponent },
  { path: 'user', component: UserComponent },
  { path: 'tab', component: TabComponent },
  { path: 'assemblyInput', component: AssemblyRegisterComponent },
  { path: 'consultaaplicacao', component: SearchApplicationComponent },

  { path: 'providers', component: ProviderComponent },
  { path: 'entities', component: EntityComponent },
  { path: 'report', component: ReportComponent },
  { path: 'report/view/:id', component: ReportViewComponent },
  { path: 'report/report-menu-pre-view/report', component: ReportMenuPreViewComponent },

  { path: 'exibirRelatorio', component: ReportViewComponent },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes)]
})

export class AppRoutingModule { }
